import { useCallback } from 'react'

import { GTM } from '../../../../../../helpers'
import nrLogger from '../../../../../../helpers/nrLogger'
import { getCpcidFromSession, getPromotionDetails, storePromoDetailsInLocalStorage } from '../../../../../../helpers/promotions'

const useExecuteGTM = ({
  index,
  pageType,
  data,
  selectedVehicle,
  invObj,
  groundDeliveryTime,
  widgetName = '',
  executeEcomATCEvent,
  cartId,
}) => {
  const {
    addToCart: addToCartGTM,
    getProductFromDetails,
    blueshiftAddToCart,
    ecomAddToCartProductsGTM
  } = GTM

  return useCallback(
    () => {
      try {
        addToCartGTM({
          productList: pageType === 'mntsrp' ? 'Maintenance Recommendations' : 'Product Listing',
          productListPosition: index + 1,
          products: [
            getProductFromDetails(
              {
                ...data,
                vehicle: selectedVehicle,
                inventory: invObj,
                groundDeliveryTime,
              },
              1,
            ),
          ],
        })

        if (executeEcomATCEvent) {
          const cpcid = getCpcidFromSession()
          const promotionDetails = getPromotionDetails(cpcid)

          ecomAddToCartProductsGTM({
            quantity: 1,
            widgetName,
            product: data,
            inventory: invObj,
            groundDeliveryTime,
            selectedVehicle,
            ...(promotionDetails && { promotionDetails }),
          })

          if (promotionDetails) {
            storePromoDetailsInLocalStorage(data.sku, cpcid)
          }
        }

        blueshiftAddToCart({
          cart_id: cartId,
          email: null,
          product: {
            ...data,
            vehicle: selectedVehicle,
          },
          quantity: 1,
        })
      } catch (error) {
        console.error('error in useExecuteGTM', error?.message || error)
        nrLogger.error('ShoppingCartV2.AddButtonForPL.useAddToCartPL.useExecuteGTM.error', error)
      }
    },
    [
      index,
      pageType,
      data,
      selectedVehicle,
      invObj,
      groundDeliveryTime,
      addToCartGTM,
      getProductFromDetails,
      blueshiftAddToCart,
      ecomAddToCartProductsGTM,
      cartId,
    ],
  )
}

export default useExecuteGTM
